import { render } from "./addModule.vue?vue&type=template&id=73c5e811&scoped=true"
import script from "./addModule.vue?vue&type=script&lang=js"
export * from "./addModule.vue?vue&type=script&lang=js"

import "./addModule.vue?vue&type=style&index=0&id=73c5e811&lang=less&scoped=true"

import exportComponent from "E:\\self\\loyi\\pro-DT-member-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c5e811"]])

export default __exports__